/* eslint-disable */
import * as Types from './generated-types';

import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
export const ConfigurationFragmentDoc = gql`
    fragment Configuration on SystemConfig {
  id
  name
  moduleFieldValues {
    value
    fieldId
  }
  expertCheckStatus
  configVariantLines {
    id
    configurationSourceKey
    variant {
      variantId
      sku
      name {
        de
        en
      }
      images {
        fileName
        fileSize
        frontendFullPath
      }
      price {
        basePrice
        price
      }
    }
    quantity
  }
}
    `;
export const LanguageFragmentDoc = gql`
    fragment Language on TranslatedString {
  de
  en
}
    `;
export const SystemTooltipFragmentDoc = gql`
    fragment SystemTooltip on SystemTooltip {
  title
  description
  image
}
    `;
export const SystemFragmentDoc = gql`
    fragment System on System {
  id
  name
  code
  subTitle
  modules {
    id
    name
    optional
    code
    perZug
    tooltip {
      ...SystemTooltip
    }
    fields {
      id
      validation {
        min
        max
      }
      name
      valueType
      unit
      options {
        key
        value
      }
      defaultValue
      hideConditions {
        field
        operator
        value
        disableIfHidden
        condition
      }
      code
      tooltip {
        ...SystemTooltip
      }
    }
  }
}
    ${SystemTooltipFragmentDoc}`;
 const AcknowledgeExpertCheckDocument = gql`
    mutation AcknowledgeExpertCheck($systemConfigId: String!) {
  acknowledgeExpertCheck(systemConfigId: $systemConfigId) {
    __typename
    ... on SystemConfig {
      id
      name
      expertCheckStatus
    }
    ... on SystemNotFoundError {
      message
    }
    ... on ConfigNotFoundError {
      message
    }
  }
}
    `;
 const AddConfigToBasketDocument = gql`
    mutation AddConfigToBasket($configId: String!) {
  addConfigToBasket(configId: $configId) {
    ... on Basket {
      id
    }
    ... on ConfigNotFoundError {
      message
    }
    __typename
  }
}
    `;
 const ClearBasketDocument = gql`
    mutation ClearBasket {
  clearBasket {
    __typename
    ... on Basket {
      id
    }
    ... on BasketNotFoundError {
      message
    }
  }
}
    `;
 const CreateConfigVariantLineDocument = gql`
    mutation createConfigVariantLine($input: CreateConfigVariantLineInput!) {
  createConfigVariantLine(createConfigVariantLineInput: $input) {
    __typename
  }
}
    `;
 const CreateSystemConfigDocument = gql`
    mutation CreateSystemConfig($systemId: String!) {
  createSystemConfig(systemId: $systemId) {
    __typename
    ... on SystemConfig {
      id
      name
      code
    }
    ... on SystemNotFoundError {
      message
    }
  }
}
    `;
 const DeleteSystemConfigDocument = gql`
    mutation DeleteSystemConfig($systemConfigId: String!) {
  deleteSystemConfig(systemConfigId: $systemConfigId) {
    ... on SystemConfig {
      id
      name
    }
    ... on ConfigNotFoundError {
      message
    }
    __typename
  }
}
    `;
 const FinishExpertCheckDocument = gql`
    mutation FinishExpertCheck($systemConfigId: String!, $message: String!) {
  finishExpertCheck(systemConfigId: $systemConfigId, message: $message) {
    __typename
    ... on SystemConfig {
      id
      name
      expertCheckStatus
    }
    ... on SystemNotFoundError {
      message
    }
    ... on ConfigNotFoundError {
      message
    }
  }
}
    `;
 const RemoveBasketLineDocument = gql`
    mutation RemoveBasketLine($id: String!) {
  removeBasketLine(id: $id) {
    ... on BasketLine {
      id
    }
    ... on BasketLineNotFoundError {
      message
    }
  }
}
    `;
 const RemoveConfigVariantLineDocument = gql`
    mutation RemoveConfigVariantLine($configVariantLineId: String!) {
  removeConfigVariantLine(id: $configVariantLineId) {
    ... on ConfigVariantLine {
      id
    }
    ... on ConfigNotFoundError {
      message
    }
  }
}
    `;
 const RequestExpertCheckDocument = gql`
    mutation RequestExpertCheck($id: String!, $message: String!) {
  requestExpertCheck(systemConfigId: $id, message: $message) {
    __typename
    ... on SystemConfig {
      id
      name
    }
    ... on SystemNotFoundError {
      message
    }
    ... on ConfigNotFoundError {
      message
    }
  }
}
    `;
 const SendBasketToOrderDocument = gql`
    mutation SendBasketToOrder($id: String!) {
  sendBasketToOrder(id: $id) {
    __typename
  }
}
    `;
 const UpdateBasketLineDocument = gql`
    mutation UpdateBasketLine($input: UpdateBasketLineInput!) {
  updateBasketLine(updateBasketLineInput: $input) {
    id
    quantity
  }
}
    `;
 const UpdateConfigVariantLineDocument = gql`
    mutation UpdateConfigVariantLine($configVariantLineId: String!, $quantity: Int!) {
  updateConfigVariantLine(
    updateConfigVariantLineInput: {id: $configVariantLineId, quantity: $quantity}
  ) {
    ... on ConfigVariantLine {
      id
      quantity
      variant {
        variantId
      }
    }
    ... on ConfigNotFoundError {
      message
    }
  }
}
    `;
 const UpdateSystemConfigDocument = gql`
    mutation UpdateSystemConfig($config: UpdateSystemConfigInput!) {
  updateSystemConfig(config: $config) {
    ... on SystemConfig {
      ...Configuration
      system {
        ...System
      }
      calculationErrors {
        configurationSourceKey
        type
        message
        filter
      }
    }
    ... on SystemNotFoundError {
      message
    }
    ... on ConfigNotFoundError {
      message
    }
    __typename
  }
}
    ${ConfigurationFragmentDoc}
${SystemFragmentDoc}`;
 const AccessoriesDocument = gql`
    query Accessories($systemId: String!, $filter: JSONObject!) {
  accessories(systemId: $systemId, filter: $filter) {
    variantId
    sku
    name {
      ...Language
    }
    systemName
    slug {
      ...Language
    }
    absolutePath {
      ...Language
    }
    images {
      fileName
      fileSize
      frontendFullPath
    }
    price {
      basePrice
      price
    }
  }
}
    ${LanguageFragmentDoc}`;
 const ActiveBasketDocument = gql`
    query ActiveBasket {
  activeBasket {
    id
    basketLines {
      id
      totalCost
      quantity
      systemConfig {
        id
        name
      }
      basket {
        id
        state
      }
    }
  }
}
    `;
 const ActiveCustomerDocument = gql`
    query ActiveCustomer {
  activeCustomer {
    id
    firstName
    lastName
    emailAddress
    title
  }
}
    `;
 const ContactPersonDocument = gql`
    query ContactPerson {
  contactPerson {
    image
    name
    position
    phone
    mobile
    email
  }
}
    `;
 const IsAdminDocument = gql`
    query IsAdmin($companyId: String!) {
  isAdmin(companyId: $companyId)
}
    `;
 const SystemConfigByIdDocument = gql`
    query SystemConfigById($systemConfigId: String!) {
  systemConfig(systemConfigId: $systemConfigId) {
    ...Configuration
    system {
      ...System
    }
  }
}
    ${ConfigurationFragmentDoc}
${SystemFragmentDoc}`;
 const SystemConfigsDocument = gql`
    query SystemConfigs {
  systemConfigs {
    id
    createdAt
    name
    code
    expertCheckStatus
    companyId
    customerId
  }
}
    `;
 const SystemsDocument = gql`
    query Systems {
  systems {
    id
    name
    code
    description
    enable
    buttonText
    subTitle
    modules {
      name
    }
  }
}
    `;
 const SystemsForEntryPageDocument = gql`
    query SystemsForEntryPage {
  systems {
    id
    name
    code
    buttonText
    enable
    systemFinderFilterIds
    image
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    AcknowledgeExpertCheck(variables: Types.AcknowledgeExpertCheckMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.AcknowledgeExpertCheckMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.AcknowledgeExpertCheckMutation>({ document: AcknowledgeExpertCheckDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AcknowledgeExpertCheck', 'mutation', variables);
    },
    AddConfigToBasket(variables: Types.AddConfigToBasketMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.AddConfigToBasketMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.AddConfigToBasketMutation>({ document: AddConfigToBasketDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'AddConfigToBasket', 'mutation', variables);
    },
    ClearBasket(variables?: Types.ClearBasketMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.ClearBasketMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.ClearBasketMutation>({ document: ClearBasketDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ClearBasket', 'mutation', variables);
    },
    createConfigVariantLine(variables: Types.CreateConfigVariantLineMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.CreateConfigVariantLineMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.CreateConfigVariantLineMutation>({ document: CreateConfigVariantLineDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'createConfigVariantLine', 'mutation', variables);
    },
    CreateSystemConfig(variables: Types.CreateSystemConfigMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.CreateSystemConfigMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.CreateSystemConfigMutation>({ document: CreateSystemConfigDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'CreateSystemConfig', 'mutation', variables);
    },
    DeleteSystemConfig(variables: Types.DeleteSystemConfigMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.DeleteSystemConfigMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.DeleteSystemConfigMutation>({ document: DeleteSystemConfigDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'DeleteSystemConfig', 'mutation', variables);
    },
    FinishExpertCheck(variables: Types.FinishExpertCheckMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.FinishExpertCheckMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.FinishExpertCheckMutation>({ document: FinishExpertCheckDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'FinishExpertCheck', 'mutation', variables);
    },
    RemoveBasketLine(variables: Types.RemoveBasketLineMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.RemoveBasketLineMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.RemoveBasketLineMutation>({ document: RemoveBasketLineDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'RemoveBasketLine', 'mutation', variables);
    },
    RemoveConfigVariantLine(variables: Types.RemoveConfigVariantLineMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.RemoveConfigVariantLineMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.RemoveConfigVariantLineMutation>({ document: RemoveConfigVariantLineDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'RemoveConfigVariantLine', 'mutation', variables);
    },
    RequestExpertCheck(variables: Types.RequestExpertCheckMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.RequestExpertCheckMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.RequestExpertCheckMutation>({ document: RequestExpertCheckDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'RequestExpertCheck', 'mutation', variables);
    },
    SendBasketToOrder(variables: Types.SendBasketToOrderMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.SendBasketToOrderMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.SendBasketToOrderMutation>({ document: SendBasketToOrderDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SendBasketToOrder', 'mutation', variables);
    },
    UpdateBasketLine(variables: Types.UpdateBasketLineMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.UpdateBasketLineMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UpdateBasketLineMutation>({ document: UpdateBasketLineDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateBasketLine', 'mutation', variables);
    },
    UpdateConfigVariantLine(variables: Types.UpdateConfigVariantLineMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.UpdateConfigVariantLineMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UpdateConfigVariantLineMutation>({ document: UpdateConfigVariantLineDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateConfigVariantLine', 'mutation', variables);
    },
    UpdateSystemConfig(variables: Types.UpdateSystemConfigMutationVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.UpdateSystemConfigMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.UpdateSystemConfigMutation>({ document: UpdateSystemConfigDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'UpdateSystemConfig', 'mutation', variables);
    },
    Accessories(variables: Types.AccessoriesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.AccessoriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.AccessoriesQuery>({ document: AccessoriesDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Accessories', 'query', variables);
    },
    ActiveBasket(variables?: Types.ActiveBasketQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.ActiveBasketQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.ActiveBasketQuery>({ document: ActiveBasketDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ActiveBasket', 'query', variables);
    },
    ActiveCustomer(variables?: Types.ActiveCustomerQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.ActiveCustomerQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.ActiveCustomerQuery>({ document: ActiveCustomerDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ActiveCustomer', 'query', variables);
    },
    ContactPerson(variables?: Types.ContactPersonQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.ContactPersonQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.ContactPersonQuery>({ document: ContactPersonDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'ContactPerson', 'query', variables);
    },
    IsAdmin(variables: Types.IsAdminQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.IsAdminQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.IsAdminQuery>({ document: IsAdminDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'IsAdmin', 'query', variables);
    },
    SystemConfigById(variables: Types.SystemConfigByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.SystemConfigByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.SystemConfigByIdQuery>({ document: SystemConfigByIdDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SystemConfigById', 'query', variables);
    },
    SystemConfigs(variables?: Types.SystemConfigsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.SystemConfigsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.SystemConfigsQuery>({ document: SystemConfigsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SystemConfigs', 'query', variables);
    },
    Systems(variables?: Types.SystemsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.SystemsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.SystemsQuery>({ document: SystemsDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'Systems', 'query', variables);
    },
    SystemsForEntryPage(variables?: Types.SystemsForEntryPageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders, signal?: RequestInit['signal']): Promise<Types.SystemsForEntryPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<Types.SystemsForEntryPageQuery>({ document: SystemsForEntryPageDocument, variables, requestHeaders: { ...requestHeaders, ...wrappedRequestHeaders }, signal }), 'SystemsForEntryPage', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;